import type { House, HouseResponse } from '@/types/house.types';

export const transformHouseResponse = (response: Readonly<HouseResponse>): House => {
    const { postalCode, subdivision, ...restAddress } = response.address;

    return {
        ...response,
        address: {
            ...restAddress,
            state: subdivision,
            zipCode: postalCode,
        },
    };
};
